import {Outlet} from '@github-ui/react-router'
import {testIdProps} from '@github-ui/test-id-props'

import {BaseSettingsPage} from '../../../components/base-settings-page'
import {useBindMemexToDocument} from '../../../hooks/use-bind-memex-to-document'
import {InsightsConfigurationPaneProvider} from '../hooks/use-insights-configuration-pane'
import {InsightsLayout} from './insights-layout'

export function InsightsPage() {
  useBindMemexToDocument()

  return (
    <BaseSettingsPage {...testIdProps('insights-page')}>
      <InsightsConfigurationPaneProvider>
        <InsightsLayout>
          <Outlet />
        </InsightsLayout>
      </InsightsConfigurationPaneProvider>
    </BaseSettingsPage>
  )
}

try{ InsightsPage.displayName ||= 'InsightsPage' } catch {}